/**
 * Created by sange on 15/08/2017.
 */
import { HubConnection } from '@microsoft/signalr'

import * as signalActions from '../actions/signalR.actions'

export interface State {
  status: string,
  connection: HubConnection,
}

export const initialState: State = {
  status: 'disconnected',
  connection: null
}

export function reducer(state = initialState, action: signalActions.SignalRActions): State {
  switch (action.type) {

    case signalActions.CHANGE_STATUS: {
      const {status, connection} = action.payload

      return {
        connection,
        status
      } as State
    }

    default: {
      return state
    }
  }
}

export const getStatus = (state: State) => state.status




// WEBPACK FOOTER //
// ./src/app/shared/signalR/store/reducers/signalR.reducer.ts